var _path, _mask, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkMyBills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0c26.22 0 26 11.64 26 26s.396 26-26 26S0 40.36 0 26-.22 0 26 0z",
    fill: "#000"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "9tlbbjj3ab",
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 27,
    height: 27,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 13h27v27H13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.413 19.538 25.661 38l1.564-2.935a1.75 1.75 0 0 1 2.162-.815l.887.334a1.75 1.75 0 0 0 2.179-.849l.715-1.415a1.75 1.75 0 0 1 1.917-.925L38 32l-6.488-16.306a1.75 1.75 0 0 0-2.338-.952l-10.76 4.796zM16.667 27.281l2.718-1.133-1.855-4.962a1.552 1.552 0 1 0-2.89 1.13l2.027 4.965z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.413 19.538 25.661 38l1.564-2.935a1.75 1.75 0 0 1 2.162-.815l.887.334a1.75 1.75 0 0 0 2.179-.849l.715-1.415a1.75 1.75 0 0 1 1.917-.925L38 32l-6.488-16.306a1.75 1.75 0 0 0-2.338-.952l-10.76 4.796zM16.667 27.281l2.718-1.133-1.855-4.962a1.552 1.552 0 1 0-2.89 1.13l2.027 4.965z",
    fill: "#DFF4E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.661 38-1.396.548a1.5 1.5 0 0 0 2.72.157L25.661 38zm-7.248-18.462-.61-1.37-1.31.584.524 1.335 1.396-.549zm10.76-4.796.611 1.37-.61-1.37zm2.34.951 1.393-.554-1.394.555zM38 32l-.305 1.469a1.5 1.5 0 0 0 1.699-2.024L38 32zm-2.915-.605.305-1.468-.305 1.468zm-1.917.925 1.339.676-1.34-.676zm-.715 1.416 1.339.676-1.34-.676zm-2.18.848.53-1.403-.53 1.403zm-.886-.334-.53 1.404.53-1.404zm-2.162.815-1.324-.706 1.324.706zm-7.84-8.917.578 1.385a1.5 1.5 0 0 0 .828-1.91l-1.405.525zm-2.718 1.133-1.389.567a1.5 1.5 0 0 0 1.966.818l-.577-1.385zm-2.027-4.964 1.388-.567-1.388.567zm2.89-1.13-1.405.525 1.405-.526zm-1.914-.94.445 1.433-.445-1.432zm11.442 17.205L19.81 18.99l-2.793 1.097 7.248 18.461 2.793-1.096zm-8.034-16.543 10.76-4.797-1.221-2.74-10.76 4.796 1.221 2.74zm11.094-4.661 6.488 16.306 2.788-1.109-6.488-16.306-2.788 1.109zm8.187 14.283-2.915-.604-.61 2.937 2.915.605.61-2.938zm-6.476 1.113-.715 1.415 2.678 1.353.715-1.416-2.678-1.352zm-1.027 1.537-.886-.335-1.058 2.808.887.334 1.057-2.807zm-4.901 1.178-1.564 2.936 2.648 1.41 1.564-2.935-2.648-1.41zm-7.093-9.596-2.718 1.134 1.154 2.769 2.719-1.133-1.155-2.77zm-.753 1.951-2.027-4.964-2.777 1.134 2.027 4.964 2.777-1.134zm-1.93-5.002 1.855 4.961 2.81-1.05-1.854-4.962-2.81 1.05zm-.064-.032a.052.052 0 0 1 .064.032l2.81-1.05a3.052 3.052 0 0 0-3.764-1.847l.89 2.865zm13.855 11.166A3.25 3.25 0 0 0 25.9 34.36l2.648 1.41a.25.25 0 0 1 .309-.117l1.058-2.807zm1.198.213a.25.25 0 0 1-.312.122l-1.057 2.807a3.25 3.25 0 0 0 4.047-1.576l-2.678-1.353zM16.028 21.75a.046.046 0 0 1-.004-.02.056.056 0 0 1 .018-.04.048.048 0 0 1 .02-.009l-.891-2.865a3.052 3.052 0 0 0-1.92 4.069l2.777-1.134zm19.362 8.178a3.25 3.25 0 0 0-3.561 1.717l2.678 1.352a.25.25 0 0 1 .273-.132l.61-2.937zm-5.606-13.815a.25.25 0 0 1 .334.136l2.788-1.109a3.25 3.25 0 0 0-4.343-1.767l1.221 2.74z",
    fill: "url(#q3ufv9huna)",
    mask: "url(#9tlbbjj3ab)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.047 27.125-2.469-5.86-.019.138c-.049.35-.004.707.13 1.034l1.983 4.844.375-.156zM25.688 38.125l-7.25-18.563.812-.375 7.063 17.875-.625 1.063z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m26.998 29.786 5.393-2.446",
    stroke: "url(#jshu5v8o8c)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m25.445 26.138 5.393-2.447",
    stroke: "url(#z4r4kb6yrd)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m24.151 22.954 5.393-2.446",
    stroke: "url(#li9dy065ee)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "q3ufv9huna",
    x1: 26,
    y1: 14,
    x2: 26,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jshu5v8o8c",
    x1: 32.465,
    y1: 26.859,
    x2: 28.116,
    y2: 27.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z4r4kb6yrd",
    x1: 30.911,
    y1: 23.211,
    x2: 26.563,
    y2: 23.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "li9dy065ee",
    x1: 29.617,
    y1: 20.027,
    x2: 25.269,
    y2: 20.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMyBills);
export default __webpack_public_path__ + "static/media/darkMyBills.74a7a690644e94627df3fdc4c408fffd.svg";
export { ForwardRef as ReactComponent };